namespace GeniuzPOS.Inventory {
    export class IcStockBacProcessingColumns {
        static columnsKey = 'Inventory.IcStockBacProcessing';
    }
}
